export const MemberType = {
  Buyer: 'buyer',
  Investor: 'invester',
  VipBuyer: 'vip_buyer',
  VipInvestor: 'vip_invester',
  Seller: 'seller'
}

export const MEMBER_TYPE_OPTIONS = [
  { value: MemberType.Buyer, text: 'buyer' },
  { value: MemberType.Investor, text: 'investor' },
  { value: MemberType.VipBuyer, text: 'buyer_vip' },
  { value: MemberType.VipInvestor, text: 'investor_vip' }
]



// WEBPACK FOOTER //
// ./src/constants/juzmatch.js